document.addEventListener("DOMContentLoaded", function() {


    // Add event listener to each element to extend the label clickabilty for "pro" & "home" labels
    // Get all elements with the class '.product-label-description'
    const labelDescriptions = document.querySelectorAll('.product-label-description');

    labelDescriptions.forEach(function(description) {
        description.addEventListener('click', function() {
            
            // Get the previous sibling of the clicked element
            let previousElement = description.previousElementSibling;

            // Ensure the previous element is a <label> and trigger a click on it
            if (previousElement && previousElement.tagName.toLowerCase() === 'label') {
                previousElement.click();
            }
        });
    });
       

    
   // Function to set "SHOP" Menu Item as active when on product pages
    var targetMenuItem = document.getElementById("HeaderMenu-shop");

    if (targetMenuItem) {
        for (var i = 0; i < targetMenuItem.children.length; i++) {
            targetMenuItem.children[i].classList.add("header__active-menu-item");
        }
    }
    

});


 // Adds eventlistner "style" variant radios to determine if "pro" or "home" is selected - then update "product-info-tabs" contents &  url parameter accordingly to improve UX
 document.addEventListener('DOMContentLoaded', function() {

    // Scripts that will be executed on page load
    autoPreSelectSetColorVariationOnLoad();

    setupProductLinkClick();


    const variantRadios = document.querySelector('variant-radios');

    // Check if there are Radio Values like "Home" or "Pro" if this is the case please add "product-form_pro-home-switcher" to target the eventlistener
    if (variantRadios) {
        const labels = variantRadios.querySelectorAll('.selection-inner-label');

        labels.forEach(function(label) {
            const textContent = label.textContent.trim().toLowerCase();

            if (textContent === 'home' || textContent === 'pro') {
                let parentFieldset = label.closest('fieldset');
                if (parentFieldset) {
                    parentFieldset.classList.add('product-form_pro-home-switcher');
                }
            }
        });
    }

    // Targeting "product-form_pro-home-switcher"
    let fieldset = document.querySelector('.product-form_pro-home-switcher');
    let mainContent = document.getElementById('MainContent');

    if (!fieldset || !mainContent) return; // Ensure elements exist

    // Helper function to update URL without reloading page
    function updateUrlParameter(key, value) {
        setTimeout(() => {
            let url = new URL(window.location.href);
            url.searchParams.set(key, value);
            window.history.replaceState({}, '', url.toString());
        }, 500);
    }

    // Helper function to set the class on MainContent
    function setMainContentClass(style) {
        mainContent.classList.toggle('tukluk-display-pro-variant', style === 'Pro');
        mainContent.classList.toggle('tukluk-display-home-variant', style === 'Home');
    }

    // Check the 'style' URL parameter and auto-select the respective radio on load
    let url = new URL(window.location.href);
    let styleParam = url.searchParams.get('style');

    if (styleParam) {
        let capitalizedStyle = styleParam.charAt(0).toUpperCase() + styleParam.slice(1);
        let radioToSelect = fieldset.querySelector(`input[type="radio"][value="${capitalizedStyle}"]`);
        if (radioToSelect) {
            radioToSelect.click();
            updateUrlParameter('style', styleParam);
            setMainContentClass(capitalizedStyle);
        }
    }

    // On change, update the URL and class based on the selected variant
    fieldset.addEventListener('change', function(event) {
        let target = event.target;

        if (target && target.type === 'radio') {
            let styleValue = target.value === 'Home' ? 'home' : 
                             target.value === 'Pro' ? 'pro' : null;

            if (styleValue) {
                updateUrlParameter('style', styleValue);
                setMainContentClass(target.value);
            }
        }
    });


    
    // PSEUDO SET COLOR SELECTION

    function autoPreSelectSetColorVariationOnLoad() {
        // Check if an element with the class 'tukluk-pseudo-set-color-section' exists
        if (!document.querySelector('.tukluk-pseudo-set-color-section')) {
            return;
        }
    

        // Retrieve the product name from the .tl-text-headline element
        const currentProductName = document.querySelector('.product__title .tl-text-headline').textContent.trim();
        // Retrieve all label elements within the .variation-selection-wrapper
        const setColorLabels = document.querySelectorAll('.variation-selection-wrapper label');
    
        // Loop through each label and check if its text content matches the current product name
        setColorLabels.forEach(label => {
            const labelName = label.textContent.trim();
            if(labelName === currentProductName) {
                // If a match is found, simulate a click on the respective input element
                
                const inputElement = label.previousElementSibling;
                if (inputElement && inputElement.tagName === 'INPUT') {
                    inputElement.checked = true;
                } else {
                    console.warn('Unexpected element:', inputElement);
                }

                // Remove the closest anchor to the label
                const closestAnchor = label.closest('.variation-selection-wrapper').querySelector('a');
                if (closestAnchor) {
                    closestAnchor.remove();
                }
            }
        });
    }


    function setupProductLinkClick() {
        // Check if elements with the class 'tukluk-pseudo-variation-product-link' exist
        const productLinks = document.querySelectorAll('.tukluk-pseudo-variation-product-link');
    
        if (!productLinks.length) {
            console.log("No elements with the class 'tukluk-pseudo-variation-product-link' found.");
            return;
        }
    
        // Add click event listener for each product link
        productLinks.forEach(link => {
            link.addEventListener('click', function(event) {
                // event.preventDefault(); 
    
                // Trigger click on closest label
                const closestLabel = link.closest('.variation-selection-wrapper').querySelector('label');
                closestLabel.click();
    
                // Fade out all .product__media-wrapper elements
                const mediaWrappers = document.querySelectorAll('.product__media-wrapper');
                
                if (mediaWrappers.length) {
                    mediaWrappers.forEach(mediaWrapper => {
                        fadeOut(mediaWrapper);
                    });
                } else {
                    console.log("No element with the class 'product__media-wrapper' found.");
                }
            });
        });
    }
    
    function fadeOut(element, duration = 500) {
        element.style.opacity = 1;
    
        let last = +new Date();
        const tick = () => {
            element.style.opacity = +element.style.opacity - (new Date() - last) / duration;
            last = +new Date();
    
            if (+element.style.opacity > 0) {
                (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
            } else {
                element.style.display = 'none';
            }
        };
    
        tick();
    }
    

});




// Logic to display set sizes

document.addEventListener('DOMContentLoaded', function() {

    function getSelectedSizeElement() {
        return document.querySelector('.product-form_type-Größe, .product-form_type-Size');
    }

    function markActiveSelection() {
        const sizeElement = getSelectedSizeElement();

        if (sizeElement) {
            // Find all input radio elements inside sizeElement
            const inputRadios = sizeElement.querySelectorAll('.product-form__input-variants .variation-selection-wrapper input[type="radio"]');
            
            inputRadios.forEach((input, index) => {
                if (input.checked) {
                    input.parentElement.classList.add('active-selection');
                }
            });
        }
    }

    function activateCorrespondingSetSize() {
        const sizeElement = getSelectedSizeElement();

        if (sizeElement) {
            // Find checked input
            const activeInput = sizeElement.querySelector('.product-form__input-variants .variation-selection-wrapper.active-selection input[type="radio"]');
            const index = Array.from(sizeElement.querySelectorAll('.product-form__input-variants .variation-selection-wrapper input[type="radio"]')).indexOf(activeInput);
            
            // Activate corresponding child of .tl-product-set-size
            const setSizeChildren = document.querySelectorAll('.tl-product-set-size > div');
            setSizeChildren.forEach(child => child.classList.remove('active'));  // First, remove any active class
            setSizeChildren[index] && setSizeChildren[index].classList.add('active'); // Add active class to the matched child
        }
    }

    function attachVariantListeners() {
        const sizeElement = getSelectedSizeElement();

        if (sizeElement) {
            // Select the child elements of .product-form__input-variants
            const variantInputs = sizeElement.querySelectorAll('.product-form__input-variants .variation-selection-wrapper');
            
            variantInputs.forEach((inputWrapper, index) => {
                // Add click event listener
                inputWrapper.addEventListener('click', function() {
                    // Remove previous active-selection
                    variantInputs.forEach(wrapper => wrapper.classList.remove('active-selection'));
                    // Add new active-selection
                    inputWrapper.classList.add('active-selection');
                    
                    // Activate the corresponding child of .tl-product-set-size
                    const setSizeChildren = document.querySelectorAll('.tl-product-set-size > div');
                    setSizeChildren.forEach(child => child.classList.remove('active'));
                    setSizeChildren[index] && setSizeChildren[index].classList.add('active');
                });
            });
        }
    }

    // Initialize
    markActiveSelection();
    activateCorrespondingSetSize();
    attachVariantListeners();

});




// IMPLEMENTATION OF GALLERY ON CLICK SLIDE THROUGH LOGIC + UX Improved Click and Touch behaviour & MULTIPLE IMAGES PER VARIANT LOGIC ON LOAD (Extended in global.js after variation selection in LINE 908)
// CHAT GPT: https://chat.openai.com/share/ca8476a4-d367-43ca-af58-26953f8da1fe


document.addEventListener("DOMContentLoaded", function() {

        
    // Access current product selection: Extract JSON data from the script tag within variantRadiosElement
    const variantRadiosElement = document.querySelector('variant-radios');
    const scriptContent = variantRadiosElement ? variantRadiosElement.querySelector('script[type="application/json"]').textContent : null;
    const variants = scriptContent ? JSON.parse(scriptContent) : null;

    // Proceed only if variants are available
    if (variants && variants.length) {
        // Retrieve the variant value from the URL
        const urlParams = new URLSearchParams(window.location.search);
        const variantIdFromUrl = urlParams.get('variant');

        // Determine the currentVariant by URL id or by defaulting to the first available variant
        let currentVariant = variants.find(variant => variant.id.toString() === variantIdFromUrl) || variants[0];

        if (currentVariant && currentVariant.featured_media) {
            const { alt, ...currentVariantMedia } = currentVariant.featured_media;

            // Hide all thumbnails initially
            const allThumbnailAltElems = document.querySelectorAll('[thumbnail-alt]');
            allThumbnailAltElems.forEach(img => img.style.display = 'none');

            // Display only thumbnails that match the current variant's alt text
            if (alt && currentVariantMedia) {
                const thumbnailSelector = `[thumbnail-alt='${alt}']`;
                document.querySelectorAll(thumbnailSelector).forEach(img => img.style.display = 'block');
            } else {
                // Fallback to display all non-variant-specific thumbnails if alt text or media is not available
                allThumbnailAltElems.forEach(img => {
                    if (!img.classList.contains('thumbnail-list_item--variant')) {
                        img.style.display = 'block';
                    }
                });
            }
        } else {
            // Log an error if no matching variant or media is found, or if script data was null
            console.error('No matching variant found or script data is null.');
        }
    } else {
        // Log an error if variants data is not available
        console.error('Variants data is not available.');
    }


  
 
    // Reset the thumbnail visibility to hide variation images by default
    const adjustThumbnailVisibility = () => {
        document.querySelectorAll('.thumbnail-list').forEach(thumbnailList => {
            const variantElements = thumbnailList.querySelectorAll('.thumbnail-list_item--variant');
            if (variantElements.length > 0) {
                variantElements[0].style.display = 'block'; // Setting the first element to 'display: block'
                for (let i = 1; i < variantElements.length; i++) {
                    variantElements[i].style.display = 'none'; // Setting all the next siblings to 'display: none'
                }
            }
        });
    };

    // Trigger: Adjusting visibility
    setTimeout(adjustThumbnailVisibility, 100);

    function processThumbnailList(thumbnailList, simulateClick = true, reverse = false) {
        // Find the button with attribute aria-current="true"
        const currentButton = thumbnailList.querySelector('button[aria-current="true"]');
    
        if (currentButton) {
            let li = currentButton.parentElement;
    
            let targetLi; // This will be either the next or previous <li> element
            if (reverse) {
                // If reverse is true, find the previous <li> sibling without "display:none"
                targetLi = li.previousElementSibling;
                while (targetLi && targetLi.style.display === "none") {
                    targetLi = targetLi.previousElementSibling;
                }
                
                // If there's no previous sibling, find the last child of ".thumbnail-list" without "display:none"
               // If there's no previous sibling, find the last child of ".thumbnail-list" with "display:block"
                if (!targetLi) {
                    const listItems = Array.from(thumbnailList.querySelectorAll('li')).filter(li => li.style.display === "block");
                    targetLi = listItems.length > 0 ? listItems[listItems.length - 1] : null;
                }

            } else {
                // This is the original behavior, to find the next <li> sibling
                targetLi = li.nextElementSibling;
                while (targetLi && targetLi.style.display === "none") {
                    targetLi = targetLi.nextElementSibling;
                }
                
                // If there's no next sibling, find the first child of ".thumbnail-list" without "display:none"
                if (!targetLi) {
                    targetLi = thumbnailList.querySelector('li:not([style*="display:none"])');
                }
            }
    
            // Simulate click event on the button inside the found <li>
            if (simulateClick && targetLi) {
                const buttonInsideTargetLi = targetLi.querySelector('button');
                if (buttonInsideTargetLi) {
                    buttonInsideTargetLi.click();
                }
            }
        }
    }

    
   // Check if element with class "thumbnail-slider" exists
    if (document.querySelector('.thumbnail-slider')) {
    
        // Add click event listener to elements with class "product__media"
        const productMediaEls = document.querySelectorAll('.product__media');
        productMediaEls.forEach(el => {
            el.addEventListener('click', function(event) {
                // Get the bounding rectangle of the clicked element
                const rect = el.getBoundingClientRect();
                // Determine the horizontal position where the image was clicked
                const clickX = event.clientX - rect.left; // Click position relative to the element

                // Iterate over all the ".thumbnail-list" elements
                const thumbnailLists = document.querySelectorAll('.thumbnail-list');
                thumbnailLists.forEach(thumbnailList => {
                    if (clickX < rect.width / 2) {
                        // Click on the left side
                        processThumbnailList(thumbnailList, true, true); // Assuming this is the desired function call for left side click
                    } else {
                        // Click on the right side
                        processThumbnailList(thumbnailList); // Assuming this is the desired function call for right side click
                    }
                });
            });
        });
    }




   // DISABLE SLIDE EVENTS FOR MOBILE
   // GPT: https://chat.openai.com/share/e8665d89-aea6-45cb-919f-c1cefc1a6152

   const sliderElement = document.querySelector('.slider-mobile-gutter');
   let startX; // to store the starting X position
   let startY; // to store the starting Y position for determining the direction
   let isProcessed = false; // flag to check if the action has been taken during the drag
   
   sliderElement.addEventListener('touchstart', function(e) {
       startX = e.touches[0].clientX; // store the starting X position
       startY = e.touches[0].clientY; // store the starting Y position
       isProcessed = false; // Reset flag on touch start
   });
   
   sliderElement.addEventListener('touchmove', function(e) {
       const currentX = e.touches[0].clientX;
       const currentY = e.touches[0].clientY;
       const deltaX = startX - currentX;
       const deltaY = startY - currentY;
   
       // Check the absolute difference in X and Y
       if (Math.abs(deltaX) > Math.abs(deltaY)) {
           // The move is more horizontal than vertical
           if (!isProcessed) { // If action hasn't been taken yet during this drag
               // We only proceed if we have a clear horizontal drag
               if (Math.abs(deltaX) > 10) { // threshold to consider it a swipe/drag and not just a tap
                   const thumbnailLists = document.querySelectorAll('.thumbnail-list');
                   thumbnailLists.forEach(thumbnailList => {
                       if (deltaX > 0) { // Swipe Left
                           processThumbnailList(thumbnailList);
                       } else { // Swipe Right
                           processThumbnailList(thumbnailList, true);
                       }
                   });
                   isProcessed = true; // Set the flag to true after taking the action
                   e.preventDefault(); // prevent default when it's a clear swipe to handle gallery
               }
           }
       } else if (Math.abs(deltaY) > 10) { // The move is a clear vertical swipe, allow scrolling
           // If we have a more significant vertical movement, we assume the user is trying to scroll
           // Do not prevent the default action to allow for normal scrolling behavior
           isProcessed = true; // We consider the touch move as processed to prevent further action
       }
       // Note: e.preventDefault() is not called here unless it's a clear horizontal swipe
   }, { passive: false });
   
   sliderElement.addEventListener('touchend', function(e) {
       // It's safe to always reset the processed flag on touch end because no default action needs to be prevented here
       isProcessed = false; // Reset flag on touch end
   });
   



});

